import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TCurrencyDetails,
	TCurrencyIdRequest,
	TCurrencyListResponse,
	TCurrencyManagementRequest,
	TCurrencyStore,
	TUpdateCurrencyRequest,
} from './types';

// ==========================================:
export const initialState: TCurrencyStore = {
	currencyList: null,
	currencyListLoading: false,
	currencyLastListParams: null,
	currencyDetails: null,
	currencyDetailsLoading: false,
	currencySaveLoading: false,
	currencySaveSuccess: false,
};

// ==========================================:
const currency = createSlice({
	name: '@@currency',
	initialState,
	reducers: {
		getCurrencyListRequest: (state, action: PayloadAction<TCurrencyManagementRequest>) => {
			state.currencyListLoading = true;
			state.currencyLastListParams = action.payload;
		},
		getCurrencyListSuccess: (state, action: PayloadAction<TCurrencyListResponse>) => {
			state.currencyList = action.payload;
			state.currencyListLoading = false;
		},
		getCurrencyListFailure: (state) => {
			state.currencyListLoading = false;
		},

		getCurrencyDetailsRequest: (state, _action: PayloadAction<TCurrencyIdRequest>) => {
			state.currencyDetailsLoading = true;
		},
		getCurrencyDetailsSuccess: (state, action: PayloadAction<TCurrencyDetails>) => {
			state.currencyDetails = action.payload;
			state.currencyDetailsLoading = false;
		},
		getCurrencyDetailsFailure: (state) => {
			state.currencyDetailsLoading = false;
		},
		clearCurrencyDetails: (state) => {
			state.currencyDetails = null;
		},

		updateCurrencyRequest: (state, _action: PayloadAction<TUpdateCurrencyRequest>) => {
			state.currencySaveLoading = true;
			state.currencySaveSuccess = false;
		},
		saveCurrencySuccess: (state) => {
			state.currencySaveLoading = false;
			state.currencySaveSuccess = true;
		},
		saveCurrencyFailure: (state) => {
			state.currencySaveLoading = false;
		},
		resetSaveCurrencySuccess: (state) => {
			state.currencySaveSuccess = false;
		},

		currencyInitState: () => initialState,
	},
});

export default currency.reducer;
export const {
	getCurrencyListRequest,
	getCurrencyListSuccess,
	getCurrencyListFailure,
	getCurrencyDetailsRequest,
	getCurrencyDetailsSuccess,
	getCurrencyDetailsFailure,
	clearCurrencyDetails,
	updateCurrencyRequest,
	saveCurrencySuccess,
	saveCurrencyFailure,
	resetSaveCurrencySuccess,
	currencyInitState,
} = currency.actions;
